import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UtilisateurDto} from '../dto/utilisateur.dto';
import {Observable} from 'rxjs';
import {PreferencesUtilisateurDto} from '../components/menu/preferences/model/preferences-utilisateur.dto';

@Injectable({
	providedIn: 'root'
})
export class UtilisateurSigalettService {

	private url = '/ws/utilisateurs';

	constructor(private http: HttpClient) {
	}

	rechercherUtilisateursPourAutocomplete(loginNomOuPrenom: string): Observable<UtilisateurDto[]> {
		const params = new HttpParams()
			.set('loginNomOuPrenom', loginNomOuPrenom)
			.set('use-case', 'autocomplete');
		return this.http.get<UtilisateurDto[]>(this.url, {params: params});
	}

	/**
	 * Enregistre les préférences de l'utilisateur.
	 *
	 * @param login le logn de l'utilisateur.
	 * @param preferences les préférences à enregistrer.
	 */
	enregistrerPreferences(login: string, preferences: PreferencesUtilisateurDto): Observable<void> {
		return this.http.put<void>(`${this.url}/${login}/preferences`, preferences);
	}

	/**
	 * Récupère les préférences de l'utilisateur.
	 *
	 * @param login le login de l'utilisateur
	 */
	rechercherPreferencesUtilisateur(login: string): Observable<PreferencesUtilisateurDto> {
		const params = new HttpParams()
			.set('login', login);
		return this.http.get<PreferencesUtilisateurDto>(`${this.url}/preferences`, {params: params});
	}
}
